import PropTypes from 'prop-types';

const B = PropTypes.bool;
const S = PropTypes.string;
const OO = PropTypes.oneOf;
const O = PropTypes.oneOfType;

const RESP = O([
  PropTypes.shape({
    xs: S,
    sm: S,
    md: S,
    lg: S,
    xl: S,
  }),
  S,
]);

const DIR = PropTypes.shape({
  x: RESP,
  y: RESP,
  t: RESP,
  l: RESP,
  b: RESP,
  r: RESP,
});

const ROUNDED_DIR = PropTypes.shape({
  t: RESP,
  l: RESP,
  b: RESP,
  r: RESP,
  tl: RESP,
  bl: RESP,
  tr: RESP,
  br: RESP,
});

const TEXT_SIZES = OO([
  'tiny',
  'caption',
  'body',
  'paragraph',
  'subheader',
  'title',
  'heading',
  'display1',
  'display2',
  'display3',
]);

const SHADOW = OO(['1', '2', '3', '4', '5']);

const FONT_FAMILY = OO(['primary', 'secondary', 'code']);

export const PropTypesRepo = {
  // set the display property
  d: O([S, RESP]),
  pos: O([S, RESP]),
  top: O([S, RESP]),
  bottom: O([S, RESP]),
  left: O([S, RESP]),
  right: O([S, RESP]),
  justify: O([S, RESP]),
  align: O([S, RESP]),
  flexDir: O([S, RESP]),
  flexGrow: O([S, RESP]),
  flexWrap: O([S, RESP]),
  order: O([S, RESP]),
  m: O([S, DIR]),
  p: O([S, DIR]),
  rounded: O([S, RESP, ROUNDED_DIR]),
  border: O([S, DIR]),
  borderColor: S,
  h: O([S, RESP]),
  maxH: O([S, RESP]),
  minH: O([S, RESP]),
  w: O([S, RESP]),
  maxW: O([S, RESP]),
  minW: O([S, RESP]),
  cursor: O([S, RESP]),
  bg: S,
  bgImg: S,
  bgSize: O([S, RESP]),
  bgRepeat: O([S, RESP]),
  bgPos: O([S, RESP]),
  textSize: O(S, TEXT_SIZES),
  textColor: S,
  textWeight: O([S, RESP]),
  textAlign: O([S, RESP]),
  verticalAlign: O([S, RESP]),
  textTransform: O([S, RESP]),
  textDecor: O([S, RESP]),
  shadow: O([S, SHADOW]),
  transition: B,
  fontFamily: FONT_FAMILY,
  transform: O([S, RESP]),
  transformOrigin: O([S, RESP]),
  zIndex: O([S, RESP]),
  overflow: S,
  opacity: O([S, RESP]),

  // Hover
  hoverBg: S,
  hoverTextColor: S,
  hoverBorderColor: S,
  hoverShadow: O([S, SHADOW]),
  hoverColor: S,
  hoverTransform: O([S, RESP]),

  // Focus
  focusBg: S,
  focusTextColor: S,
  focusBorderColor: S,
  focusShadow: SHADOW,

  // Placeholder
  placeholderTextColor: S,

  // Grids
  size: O([S, RESP]),
  offset: O([S, RESP]),
};
